





import FitIcon from '@/fit-ui/packages/icon';
import { FitToast } from '@/fit-ui';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { LoadingType } from './business';
import store from './store';

@Component({
  components: {
    FitIcon,
    FitToast,
  },
})
export default class FitLoading extends Vue {
  get showDotLine() {
    return this.loading.type === LoadingType.Security;
  }
  public loading = store.loading;
  @Prop({ default: 'loading' }) public type!: string;
}
